import * as Sentry from "@sentry/react";
import Constants from "common/constant";
import { useAnalytics } from "./useAnalytics";
import { useNativeMessage } from "./useNativeMessage";

Sentry.init({
  dsn: Constants.sentryDSN,
  integrations: [
    Sentry.consoleLoggingIntegration({
      levels: ["error"],
    }),
  ],
  tracesSampleRate: 0.2,
  environment: Constants.sentryEnv,
  release: `${Constants.sentryReleasePrefix}-ver${Constants.major}.${Constants.minor}.${Constants.buildNumber}`,
});

export const useInitialApp = () => {
  useAnalytics();
  useNativeMessage();
};
